import type { ResolvedWidgetDimensions, WidgetDimensions, WidgetSpan } from "./dashboard.types";

const STATS_PER_ROW = 6;
const STAT_MIN_COLS = 2;
const MULTI_COLUMN_MIN_COLS = 12;

const STAT_CARD_DIMENSIONS: WidgetDimensions = {
    span: "stat",
    defaultHeight: 3,
    minW: 2,
    minH: 2,
    maxH: 5,
};

const WIDGET_DIMENSION_MAP: Record<string, WidgetDimensions> = {
    ATTENTION_TASKS: STAT_CARD_DIMENSIONS,
    YOUR_RISKS: STAT_CARD_DIMENSIONS,
    YOUR_OPPORTUNITIES: STAT_CARD_DIMENSIONS,
    OVERDUE_ISSUES: STAT_CARD_DIMENSIONS,
    YOUR_ISSUES: STAT_CARD_DIMENSIONS,
    YOUR_IMPROVEMENTS: STAT_CARD_DIMENSIONS,
    LISTS: { span: "half", defaultHeight: 9, minW: 3, minH: 5, maxH: 14 },
    ISSUES_CATEGORY: { span: "half", defaultHeight: 9, minW: 4, minH: 6, maxH: 14 },
    ISSUES_STATUS: { span: "half", defaultHeight: 9, minW: 4, minH: 6, maxH: 14 },
    YEARLY_CYCLE: { span: "half", defaultHeight: 10, minW: 4, minH: 8, maxH: undefined },
    MOST_VISITED_PAGES: { span: "half", defaultHeight: 9, minW: 4, minH: 6, maxH: 14 },
    ANNOUNCEMENTS: { span: "half", defaultHeight: 9, minW: 3, minH: 5, maxH: 14 },
    SHORTCUTS: { span: "full", defaultHeight: 5, minW: 3, minH: 3, maxH: undefined },
};

const DEFAULT_DIMENSIONS: WidgetDimensions = {
    span: "half",
    defaultHeight: 9,
    minW: 3,
    minH: 4,
    maxH: undefined,
};

export function getWidgetDimensions(widgetId: string): WidgetDimensions {
    return WIDGET_DIMENSION_MAP[widgetId] || DEFAULT_DIMENSIONS;
}

export function resolveSpan(span: WidgetSpan, cols: number): number {
    switch (span) {
        case "full":
            return cols;
        case "half":
            return cols >= MULTI_COLUMN_MIN_COLS ? Math.ceil(cols / 2) : cols;
        case "stat":
            return Math.max(STAT_MIN_COLS, Math.floor(cols / STATS_PER_ROW));
    }
}

export function resolveWidgetDimensions(widgetId: string, cols: number): ResolvedWidgetDimensions {
    const { span, defaultHeight, minW, minH, maxH } = getWidgetDimensions(widgetId);
    const w = Math.min(resolveSpan(span, cols), cols);

    return { w, h: defaultHeight, minW: Math.min(minW, w), minH, maxH };
}
